













































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Api from '@/api'
import { User } from '@/classes/User'
import { FacilityModule } from '@/store/modules/facility.module'
import { CONSTANTS, ICommissionsSettings, IUser, IUserChainRole } from '@zunta/configurations'
import { UserModule } from '@/store/modules/user.module'
import InputDateRangePicker from '@/components/inputs/InputDateRangePicker.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import { numeric, required } from 'vuelidate/lib/validators'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'

const { SALES_REP_ROLE_NAME } = CONSTANTS
@Component({
  name: 'EditCommissionSettingsModal',
  props: {
    facility: {
      type: Number,
      required: true
    }
  },
  components: {
    InputValidator,
    InputV2,
    SelectV2,
    ModalV2,
    Icon,
    InputDateRangePicker
  }
})
export default class EditCommissionSettingsModal extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)

  user: User | null = Api.getUser()
  commissionSettings: Partial<ICommissionsSettings>[] = []
  isLoading: boolean = false

  validations (): any {
    return {
      commissionSettings: {
        $each: {
          user: {
            required
          },
          rate: {
            required,
            numeric
          }
        }
      }
    }
  }

  get facilityId () {
    return this.$route.params.id
  }

  get settings () {
    return this.$store.state.facility.commissionsSettings
  }

  get billingSettings () {
    return this.$store.state.facility.billingSettings
  }

  get salesReps () {
    return this.$store.state.user.users.filter((user: IUser) => (
      (user.role as IUserChainRole).name === SALES_REP_ROLE_NAME
    ))
  }

  get userItemList () {
    return this.salesReps.map((user: IUser) => {
      return {
        value: user.id,
        content: `${user.firstName} ${user.lastName}`,
        key: user.id
      }
    })
  }

  updateDateRange (commisionsSettings: ICommissionsSettings, dates: Array<string>) {
    if (dates) {
      const [dateFrom, dateTo] = dates
      commisionsSettings.startDate = new Date(dateFrom)
      commisionsSettings.endDate = new Date(dateTo)
    } else {
      // @ts-ignore
      commisionsSettings.startDate = null
      // @ts-ignore
      commisionsSettings.endDate = null
    }
  }

  mounted () {
    this.commissionSettings = JSON.parse(JSON.stringify(this.settings))
    if (this.commissionSettings.length === 0) {
      this.addUser()
    }
  }

  addUser () {
    this.commissionSettings.push({})
  }

  removeItem (index: number) {
    this.commissionSettings.splice(index, 1)
    this.$nextTick(() => {
      if (this.commissionSettings.length === 0) {
        this.addUser()
      }
    })
  }

  async save () {
    this.$v.$touch()

    if (this.$v.$anyError) {
      return
    }

    const prepareSettings = (settings: Partial<ICommissionsSettings>[]) => {
      const pSettings: Partial<ICommissionsSettings>[] = []
      settings.forEach((setting) => {
        pSettings.push({
          ...setting,
          facility: this.$props.facility,
          // @ts-ignore
          user: typeof setting.user === 'number' ? setting.user : setting.user.id
        })
      })
      return pSettings
    }

    try {
      this.isLoading = true
      const pSettings = prepareSettings(this.commissionSettings)
      await this.facilityModuleInstance.saveCommissionsSettings({ settings: pSettings, facilityId: this.facilityId })
      this.$emit('close')
    } finally {
      this.isLoading = false
    }
  }
}
